import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import InsurancePageComponent from '../../components/Solutions/Insurance/InsurancePageComponent';
import { apiRequest } from '../../components/util/requests/requests';
import { PageMetadata } from '../../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';

export interface InsuranceProps {
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const pageMetadata = await apiRequest(
        '/meta-pages?filters[key]=SOLUTIONS_INSURANCE_PAGE&populate[0]=seo'
    );

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const Insurance = ({ pageMetadata }: InsuranceProps) => (
    <Layout seoMetadata={pageMetadata?.seo} defaultMetaTitle={'Noria.no - Solutions - Insurance'}>
        <InsurancePageComponent />
    </Layout>
);

export default Insurance;
